export const isEAN = (str) => {
  //according to wiki, EAN is a 13 digit integer
  return /^\d{13}$/.test(str?.toString());
};
